import { render, staticRenderFns } from "./OutingRegister.vue?vue&type=template&id=80bb10b4&scoped=true&lang=pug"
import script from "./OutingRegister.vue?vue&type=script&lang=ts"
export * from "./OutingRegister.vue?vue&type=script&lang=ts"
import style0 from "./OutingRegister.vue?vue&type=style&index=0&id=80bb10b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80bb10b4",
  null
  
)

export default component.exports